import React from 'react';
import { motion } from 'framer-motion';

const ProblemSolution = () => (
  <motion.section
    className="max-w-5xl mx-auto py-10 md:py-16 px-2 md:px-4 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.8, ease: 'easeOut' }}
  >
    <div className="bg-white rounded-xl shadow-soft p-4 md:p-6">
      <h2 className="text-lg md:text-xl font-bold text-primary mb-4">Common Industry Issues</h2>
      <ul className="list-disc pl-5 text-primary space-y-2 text-base md:text-lg">
        <li>Delivery delays</li>
        <li>Opaque pricing</li>
        <li>Credit & payment issues</li>
        <li>Quality inconsistencies</li>
      </ul>
    </div>
    <div className="bg-white rounded-xl shadow-soft p-4 md:p-6">
      <h2 className="text-lg md:text-xl font-bold text-accent mb-4">How Houzzdat Solves Them</h2>
      <ul className="list-disc pl-5 text-primary space-y-2 text-base md:text-lg">
        <li>Assured, on-time delivery</li>
        <li>Transparent, upfront pricing</li>
        <li>Access to flexible credit</li>
        <li>Strict quality checks</li>
      </ul>
    </div>
  </motion.section>
);

export default ProblemSolution; 